var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"theme-font-regular font-16",domProps:{"innerHTML":_vm._s(_vm.expandedVwTxt)}})]),_c('CalendarEventsList',{attrs:{"calendar-events-list":_vm.content.eventsResults,"limit":_vm.limit,"show-date":true,"show-error":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }